export function flashNotice(message, title) {
    if (title === void 0) { title = ''; }
    toastr.info(message, title, {
        showDuration: "300",
        hideDuration: "1000",
        timeOut: "5000",
        extendedTimeOut: "1000",
        progressBar: true,
        allowHtml: true,
        positionClass: "toast-top-center"
    });
}
export function flashError(message, title) {
    if (title === void 0) { title = ''; }
    toastr.error(message, title, {
        closeButton: true,
        allowHtml: true,
        showDuration: "300",
        hideDuration: "1000",
        timeOut: "0",
        extendedTimeOut: "0",
        progressBar: true,
        positionClass: "toast-top-center"
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmxhc2guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJGbGFzaC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLFVBQVUsV0FBVyxDQUFDLE9BQWUsRUFBRSxLQUFrQjtJQUFsQixzQkFBQSxFQUFBLFVBQWtCO0lBQzdELE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTyxFQUFFLEtBQUssRUFBRTtRQUM1QixZQUFZLEVBQUUsS0FBSztRQUNqQixZQUFZLEVBQUUsTUFBTTtRQUNwQixPQUFPLEVBQUUsTUFBTTtRQUNmLGVBQWUsRUFBRSxNQUFNO1FBQ3ZCLFdBQVcsRUFBRSxJQUFJO1FBQ2pCLFNBQVMsRUFBRSxJQUFJO1FBQ2YsYUFBYSxFQUFFLGtCQUFrQjtLQUFDLENBQUMsQ0FBQTtBQUN2QyxDQUFDO0FBRUQsTUFBTSxVQUFVLFVBQVUsQ0FBQyxPQUFlLEVBQUUsS0FBa0I7SUFBbEIsc0JBQUEsRUFBQSxVQUFrQjtJQUM1RCxNQUFNLENBQUMsS0FBSyxDQUFDLE9BQU8sRUFBRSxLQUFLLEVBQUU7UUFDM0IsV0FBVyxFQUFFLElBQUk7UUFDakIsU0FBUyxFQUFFLElBQUk7UUFDZixZQUFZLEVBQUUsS0FBSztRQUNuQixZQUFZLEVBQUUsTUFBTTtRQUNwQixPQUFPLEVBQUUsR0FBRztRQUNaLGVBQWUsRUFBRSxHQUFHO1FBQ3BCLFdBQVcsRUFBRSxJQUFJO1FBQ2pCLGFBQWEsRUFBRSxrQkFBa0I7S0FBQyxDQUFDLENBQUE7QUFDdkMsQ0FBQyJ9